import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

export const HIGH_DENOMINATION_LOCALES = [
  PageLocaleEnum.ALBANIA,
  PageLocaleEnum.RUSSIAN,
  PageLocaleEnum.JAPANESE,
  PageLocaleEnum.TURKISH,
  PageLocaleEnum.SLOVENIAN,
  PageLocaleEnum.SERBIAN,
  PageLocaleEnum.HUNGARIAN,
  PageLocaleEnum.CZECH,
  PageLocaleEnum.INDONESIAN,
  PageLocaleEnum.HINDI,
  PageLocaleEnum.THAI,
  PageLocaleEnum.UKRAINIAN,
]

export const UNLIMITED_THRESHOLD = 100000
export const UNLIMITED_VARIANTS_THRESHOLD = 400

export const GROUP_TITLE = {
  contacts: 'components.price_element.group.contacts_and_crm',
  emailMarketing: 'components.price_element.group.email_marketing',
  automationAndWorkflows:
    'components.price_element.group.automation_and_workflows',
  sales: 'components.price_element.group.sales',
  subaccounts: 'components.price_element.group.subaccounts',
  booking: 'components.price_element.group.booking',
  payment: 'components.price_element.group.payment',
  blogs: 'components.price_element.group.blogs',
  link: 'components.price_element.group.link',
  website: 'components.price_element.group.websites',
  eCommerce: 'components.price_element.group.e_commerce',
  courses: 'components.price_element.group.courses',
  communities: 'components.price_element.group.communities',
  affiliate: 'components.price_element.group.affiliate',
  support: 'components.price_element.group.support',
  team: 'components.price_element.group.team',
  integrations: 'components.price_element.group.integrations',
  perks: 'components.price_element.group.perks',
  smsMarketing: 'components.price_element.group.sms_marketing',
}

export const PRICE_PLAN_TITLE = {
  contacts: 'components.price_element.plans.contacts',
  emailsSent: 'components.price_element.plans.email_sent',
  crmPipelines: 'components.price_element.plans.crm_pipelines',
  emailCampaigns: 'components.price_element.plans.email_campaigns',
  emailNewsletters: 'components.price_element.plans.email_newsletters',
  automationRules: 'components.price_element.plans.automation_rules',
  workflows: 'components.price_element.plans.workflows',
  tags: 'components.price_element.plans.tags',
  api: 'components.price_element.plans.api',
  salesFunnels: 'components.price_element.plans.sales_funnels',
  salesFunnelsSteps: 'components.price_element.plans.sales_funnels_steps',
  deadlineFunnels: 'components.price_element.plans.deadline_funnels',
  evergreenWebinars: 'components.price_element.plans.evergreen_webinars',
  tests: 'components.price_element.plans.tests',
  customDomains: 'components.price_element.plans.custom_domains',
  fileStorageSpace: 'components.price_element.plans.file_storage_space',
  clickUpsells: 'components.price_element.plans.click_upsells',
  orderBumps: 'components.price_element.plans.order_bumps',
  transactionFees: 'components.price_element.plans.transaction_fees',
  websites: 'components.price_element.plans.websites',
  websiteLocales: 'components.price_element.plans.languages_per_website',
  events: 'components.price_element.plans.events',
  bookings: 'components.price_element.plans.bookings',
  stripe: 'components.price_element.plans.stripe',
  applePay: 'components.price_element.plans.apple_pay',
  paypal: 'components.price_element.plans.paypal',
  razorpay: 'components.price_element.plans.razorpay',
  flutterwave: 'components.price_element.plans.flutterwave',
  mercadoPago: 'components.price_element.plans.mercado_pago',
  paystack: 'components.price_element.plans.paystack',
  xendit: 'components.price_element.plans.xendit',
  cash: 'components.price_element.plans.cash',
  variantsPerProduct: 'components.price_element.plans.variants_per_product',
  blogs: 'components.price_element.plans.blogs',
  blogPosts: 'components.price_element.plans.blogs_posts',
  mobileLink: 'components.price_element.plans.mobile_link',
  mobileStore: 'components.price_element.plans.mobile_store',
  physicalProducts: 'components.price_element.plans.physical_products',
  shippingManagement: 'components.price_element.plans.shipping_management',
  inventoryManagement: 'components.price_element.plans.inventory_management',
  courses: 'components.price_element.plans.courses',
  students: 'components.price_element.plans.students',
  studentsActivityHistory:
    'components.price_element.plans.students_activity_history',
  communities: 'components.price_element.plans.communities',
  communityMembers: 'components.price_element.plans.community_members',
  affiliateProgram: 'components.price_element.plans.affiliate_program',
  support: 'components.price_element.plans.support',
  freeMigration: 'components.price_element.plans.free_migration',
  kickstart: 'components.price_element.plans.kickstart',
  assistantAccounts: 'components.price_element.plans.assistant_accounts',
  googleSheetsIntegration:
    'components.price_element.plans.google_sheets_integration',
  googleMeetIntegration:
    'components.price_element.plans.google_meet_integration',
  googleCalendarIntegration:
    'components.price_element.plans.google_calendar_integration',
  activeCampaignIntegration:
    'components.price_element.plans.active_campaign_integration',
  sendGridIntegration: 'components.price_element.plans.send_grid_integration',
  zoomIntegration: 'components.price_element.plans.zoom_integration',
  subaccounts: 'components.price_element.group.subaccounts',
  couponCodes: 'components.price_element.plans.coupon_codes',
  earlyAccess: 'components.price_element.plans.early_access',
  twilioSms: 'components.price_element.plans.twilio_sms',
  sms: 'components.price_element.plans.sms',
} as const

export type PricePlanTitleType =
  (typeof PRICE_PLAN_TITLE)[keyof typeof PRICE_PLAN_TITLE]

export const PRICE_GROUP_IDS = {
  contacts: 1,
  sales: 2,
  booking: 3,
  payment: 4,
  blogs: 5,
  link: 6,
  website: 19,
  eCommerce: 7,
  courses: 8,
  communities: 9,
  affiliate: 10,
  support: 11,
  team: 12,
  integrations: 13,
  subaccounts: 14,
  emailMarketing: 15,
  automationAndWorkflows: 16,
  perks: 17,
  smsMarketing: 18,
} as const

export type PriceGroupIdType =
  (typeof PRICE_GROUP_IDS)[keyof typeof PRICE_GROUP_IDS]

export const WEBSITE_EXCLUDED_PRICE_GROUPS: PriceGroupIdType[] = [
  PRICE_GROUP_IDS.affiliate,
  PRICE_GROUP_IDS.support,
  PRICE_GROUP_IDS.team,
  PRICE_GROUP_IDS.subaccounts,
  PRICE_GROUP_IDS.perks,
]

export const WEBSITE_EXCLUDED_INTEGRATIONS: PricePlanTitleType[] = [
  PRICE_PLAN_TITLE.googleSheetsIntegration,
  PRICE_PLAN_TITLE.googleCalendarIntegration,
  PRICE_PLAN_TITLE.googleMeetIntegration,
  PRICE_PLAN_TITLE.zoomIntegration,
  PRICE_PLAN_TITLE.activeCampaignIntegration,
  PRICE_PLAN_TITLE.api,
]
